import React from "react";
import { Icon } from "discover.medical.react-component-library";
import {
  lengthRequirement,
  specialCharRequirement,
  numberRequirement,
  excludedWordsRequirement,
} from "../password-requirements";
import {
  matchesLengthRegex,
  matchesNumberRegex,
  matchesSpecialCharRegex,
  containsExcludedWords,
} from "../validation";
import "./index.css";

export const PasswordValidationMessaging = (props) => {
  const checkIcon = (
    <Icon icon={{ glyph: "check", size: "xs", color: "green" }} />
  );
  const closeIcon = (
    <Icon icon={{ glyph: "close", size: "xs", color: "red" }} />
  );
  const { password, isRequiredPasswordError } = props;
  if (isRequiredPasswordError && !password)
    return (
      <div className="PasswordValidationMessaging__invalidPassword">
        <Icon icon={{ glyph: "error", size: "xs", color: "red" }} />&nbsp;
        <div className="PasswordValidationMessaging__message">Required</div>
      </div>
    );
  return (
    <>
      {password && (
        <div>
          {matchesLengthRegex(password) ? (
            <div className="PasswordValidationMessaging__validPassword">
              {checkIcon}
              <div className="PasswordValidationMessaging__message">
                {lengthRequirement}
              </div>
            </div>
          ) : (
            <div
              className="PasswordValidationMessaging__invalidPassword"
              data-testid="invalidLength"
            >
              {closeIcon}
              <div className="PasswordValidationMessaging__message">
                {lengthRequirement}
              </div>
            </div>
          )}
          {matchesNumberRegex(password) ? (
            <div className="PasswordValidationMessaging__validPassword">
              {checkIcon}
              <div className="PasswordValidationMessaging__message">
                {numberRequirement}
              </div>
            </div>
          ) : (
            <div
              className="PasswordValidationMessaging__invalidPassword"
              data-testid="invalidNumber"
            >
              {closeIcon}
              <div className="PasswordValidationMessaging__message">
                {numberRequirement}
              </div>
            </div>
          )}
          {matchesSpecialCharRegex(password) ? (
            <div className="PasswordValidationMessaging__validPassword">
              {checkIcon}
              <div className="PasswordValidationMessaging__message">
                {specialCharRequirement}
              </div>
            </div>
          ) : (
            <div
              className="PasswordValidationMessaging__invalidPassword"
              data-testid="invalidSpecialChar"
            >
              {closeIcon}
              <div className="PasswordValidationMessaging__message">
                {specialCharRequirement}
              </div>
            </div>
          )}
          {!containsExcludedWords(password) ? (
            <div className="PasswordValidationMessaging__validPassword">
              {checkIcon}
              <div className="PasswordValidationMessaging__message">
                {excludedWordsRequirement}
              </div>
            </div>
          ) : (
            <div
              className="PasswordValidationMessaging__invalidPassword"
              data-testid="invalidExcludedWords"
            >
              {closeIcon}
              <div className="PasswordValidationMessaging__message">
                {excludedWordsRequirement}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PasswordValidationMessaging;
